import { useQuery } from "@tanstack/react-query";
import { CacheKey } from "../models/cacheKey";
import { Response } from "../models/response";
import HttpClient from "../utils/network";
import {OnSiteApi} from "../apis/onsite";
import { FanCheckInInfo, FanCheckInInfoDto } from "../models/fanCheckInInfo";
import { WinningType } from "../models/enum/winningType";
import {NetworkError} from "../models/networkError";

interface UserTicketQuery {
  ticketCode: string | null;
}

interface UserOrderOrMembershipQuery {
  winnerType: WinningType;
  searchValue: string | null;
}

export function useFanInfo(
  artistId: number,
  eventId: number,
  rewardId: number,
  params: UserTicketQuery | UserOrderOrMembershipQuery,
  enabled: any = true,
) {
  const {
    data: fanInfo,
    isLoading,
    error,
    isError,
    refetch,
  } = useQuery({
    enabled: enabled,
    staleTime: 5000,
    queryKey: [CacheKey.getUserInfo, eventId, params],
    queryFn: async () => {
      try {
        let response;
        if ("ticketCode" in params && params.ticketCode) {
          response = new Response<FanCheckInInfoDto>(
            await HttpClient.request(
              OnSiteApi.queryWinnerByTicket(artistId!, eventId!, rewardId, {
                ticketCode: params.ticketCode,
              }),
            ),
          );
        } else if (
          "winnerType" in params &&
          "searchValue" in params
        ) {
          try {
            response = new Response<FanCheckInInfoDto>(
                await HttpClient.request(
                    OnSiteApi.queryWinnerByMembership(artistId!, eventId!, rewardId, {
                      winnerType: params.winnerType,
                      membershipNumber: params.searchValue!
                    }),
                ),
            );
          } catch (e) {
            if(e instanceof NetworkError && e.status === 400) {
              // not found membership number, try order search
              const order = Number.parseInt(params.searchValue!);
              if(order != null && !isNaN(order)) {
                response = new Response<FanCheckInInfoDto>(
                    await HttpClient.request(
                        OnSiteApi.queryWinnerByOrder(artistId!, eventId!, rewardId, {
                          winnerType: params.winnerType,
                          order: order,
                        }),
                    ),
                )
              }
            } else {
              console.error(e)
            }
          }
        }
        if (response) {
          return new FanCheckInInfo(response.data);
        }
      } catch (e) {
        console.error(e);
      }
      return null;
    },
  });

  return { fanInfo, isLoading, error, isError, refetch };
}
